module.exports = __webpack_public_path__ + "assets/successNote1Speck2-6d338d.svg";